import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment';
import createHistory from 'history/createBrowserHistory';
import createMemoryHistory from 'history/createMemoryHistory';
import queryString from 'query-string';

// import useQueries from 'history/lib/useQueries';

const location = queryString.parse(canUseDOM ? createHistory : createMemoryHistory);
// const location = useQueries(canUseDOM ? createHistory : createMemoryHistory)();

export default location;



// WEBPACK FOOTER //
// ./src/core/Location.js